import './Notifications.scss';
import clsx from 'clsx';
import { createPortal } from 'react-dom';
import { Notifications as MantineNotifications } from '@mantine/notifications';
import { useAppPortalHostTarget } from '../../provider/appPortalHost';

// ----Компонент--------------------------------------------------------------------------------------------------------

export interface INotificationsProps {
    /** класс для управления расположением сообщений */
    className?: string;
}

const Notifications = ({ className }: INotificationsProps) => {
    // пока открыта область со своей темой (useAppPortalHost), тосты — в её хосте порталов и в её теме
    const host = useAppPortalHostTarget();
    const list = (
        <MantineNotifications
            className={clsx('rf-notifications__list', className)}
            position="bottom-right"
            autoClose={8000}
            transitionDuration={300}
            containerWidth={440}
            zIndex={99999}
            withinPortal={!host}
        />
    );
    return host ? createPortal(list, host) : list;
};

export default Notifications;
